// @flow
import { all, call } from "redux-saga/effects";
import type { Saga } from "redux-saga";
import getPwaOfflinePage from "../../sagas/getPwaOfflinePage";

export default function* mainSaga(): Saga<void> {
  yield all([call(getPwaOfflinePage)]);
}
